import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CustomTextFieldCustom from "components/CustomTextFieldCustom";
import CustomAutoCompleteDropdown from "components/autocomplete/CustomAutocompleteDropdown";
import { Link, useNavigate } from "react-router-dom";
import TextFieldCustom from "components/TextFieldCustom";
import AutoCompleteDropdown from "components/autocomplete/AutoCompleteDropdown";
import { Autocomplete, TextField } from "@mui/material";
import uploadImage from "../../../../../src/images/upload.png";
import { handleStep } from "modules/pvs_activities/pages/stepSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  displayNotification,
  generateOptionsFromData,
  sendAPIRequest,
} from "helpers";
import { updateFilter } from "redux/filtersSlice";
import { USER_ROLES } from "constants";
import TinyMCEEditor from "modules/pvs_activities/components/TinyMCEEditor";
import SiteLoader from "pages/components/SiteLoader";
const funding = [
  { label: "self funding available", value: "Self-Funcing" },
  { label: "external funding available", value: "External-funding" },
  { label: "others", value: "others" },
];
const ARMissionManager = (props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const authData = useSelector((s) => s.auth.data);
  const [value, setValue] = React.useState(0);
  const [countries, setCountries] = useState([]);
  const [donors, setDonors] = useState([]);
  const [file, setFile] = useState(null);
  const [form, setForm] = useState({ subject: "" });
  const [countryprovince, setCountryProvince] = useState({ province: "" });
  const filters = useSelector((s) => s.filters.report_repository);
  const [missionTypes, setMissionTypes] = useState([]);
  const [fundingSource, setFundingSource] = useState(null);
  const [returnParams, setReturnParams] = useState({});
  const handleChange = (event, newValue) => {
    setFundingSource(newValue);
  };
  const [selectedDonor, setSelectedDonor] = useState({
    value: 0,
    text: "",
  });
  const [processForm, setProcessForm] = useState([]);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const getForm = async () => {
    try {
      setIsLoading(true);
      const data = await sendAPIRequest("/api/pvsa/process", "POST", {
        role_id: 5,
        id: 6,
        mission_id: 1,
      });
      const response = await data.json();
      if (response.success) {
        setIsLoading(false);
        setProcessForm(response.data);
      } else {
        setIsLoading(false);
        setError(response.message);
      }
    } catch (e) {
      setIsLoading(false);
      console.log(e);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    loadCountries();
    getDonors();
    loadMissionTypes();
    getForm();
  }, []);

  const setFilters = (payload) => {
    dispatch(updateFilter({ key: "report_repository", payload }));
  };
  const navigationFunction = (key, value) => {
    let params = { ...filters };
    params[key] = value;
    setFilters({
      ...params,
    });
    params.region_id = params.region_id.join(",");
    params.country_id = params.country_id.join(",");
    params = new URLSearchParams(params).toString();
    let temp = params;
    temp = temp.replaceAll("&", "|");
    setReturnParams(temp);
    // navigate(`/portal/document-management/?${params}`);
  };
  const countryOptions = useMemo(() => {
    return generateOptionsFromData(countries, {
      value: "id",
      label: "country_complete_name",
    });
  }, [countries]);
  const loadCountries = async (region_id = "") => {
    try {
      let params = {};
      params.region_id = filters.region_id.join(",");
      params = new URLSearchParams(params).toString();
      const req = await sendAPIRequest(`/api/country?${params}`);
      const res = await req.json();
      if (res.success) {
        setCountries(res.data);
      }
    } catch (e) {
      console.log(e);
    }
  };
  const handleFileChange = (event) => {
    const uploadedFile = event.target.files[0];
    setFile(uploadedFile);
  };
  useEffect(() => {
    // createDropZone();
  });
  // const createDropZone = () => {
  //   const dropzone = document.getElementById('dropzone');
  //   dropzone.addEventListener('dragover', event => {
  //     event.preventDefault();
  //     dropzone.classList.add('dragover');
  //   });
  //   dropzone.addEventListener('dragleave', () => {
  //     dropzone.classList.remove('dragover');
  //   });
  //   dropzone.addEventListener('drop', event => {
  //     // const validation = selectionValidator();
  //     event.preventDefault();
  //     dropzone.classList.remove('dragover');
  //     // const files = event.dataTransfer.files;
  //     // files[0].type.includes(validation.data.reportType.text.toLowerCase())
  //     //     ? getFile(files)
  //     //     : displayNotification('error', t("791", "Invalid File Type"));
  //   });
  // }
  const loadMissionTypes = async () => {
    try {
      const req = await sendAPIRequest(`/api/activity-types`);
      const res = await req.json();
      if (res.success) {
        const temp = res.data?.map(item => {
          item.name = `${item.name} - ${item.relationCompetencyType?.list_element_name}`;
          return item;
        });
        setMissionTypes(temp);
      } else {
        // displayNotification("error", `${t("222", "Error loading data")} [B]`);
      }
    } catch (e) {
      console.log(e);
      // displayNotification("error", `${t("222", "Error loading data")} [F]`);
    }
  };
  const getDonors = async () => {
    try {
      const data = await sendAPIRequest("/api/list/master/12");
      const response = await data.json();
      if (response.success) {
        setDonors(response.data);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const donorOptions = useMemo(() => {
    return generateOptionsFromData(donors, {
      value: "id",
      label: "list_element_name",
    });
  }, [donors]);
  const selectFundingSource = (value) => {
    setSelectedDonor({
      value: value.value,
      text: value.label,
    });
    setForm({ ...form, donor_id: value.value });
  };
  const handleSave = () => {
    // navigate("/portal/acknowledgementletter-missionhead");
    dispatch(handleStep({ stepNumber: 6, value: true }));
    navigate("/portal/mission-workspace-metadata/create");
  };
  return (
    <>
      <div className="container my-2">
        <div className="py-6 bg-dark text-center text-white fw-bold fs-4">
          {t(
            "-1",
            "Acknowlegement Receipt Letter Approval Process For Mission Manager"
          )}
        </div>

        {isLoading ? (
          <div className="card-body p-4">
            <SiteLoader position="relative" background="transparent" />
          </div>
        ) : (
          <>
            {error !== "" ? (
              <div className="py-6 bg-red text-center text-white fw-bold fs-4">
                {t("-1", error)}
              </div>
            ) : (
              <>
                <div className="header card-woah border border-secondary d-flex px-4 py-2 shadow-sm w-100 my-2">
                  <div className="card-title1 lh-1">
                    {t("-1", "Mission Fields")}
                  </div>
                  <div className="header-right-items d-flex align-items-center ms-auto">
                    <div className="ms-auto">
                      <Link to={"/"} className="ms-auto">
                        <button className="btn btn--primary fs-7 lh-1">
                          {" "}
                          <i className="fas fa-angle-left text-white" />
                          {t("32", "Back")}
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
                {(USER_ROLES.business_admin.includes(
                  parseInt(authData.role_id)
                ) ||
                  USER_ROLES.cbd_staff.includes(
                    parseInt(authData.role_id)
                  )) && (
                    <>
                      <div className="col-12 bg-beige mb-3">
                        <div className=" p-3 text-dark">
                          {/* <div className="row d-flex">
                    <div className="col-md-4 text-bold text-dark fs-4">Country Name: </div>
                    <div className="col-md-8 text-bold">Phillipine</div>
                  </div> */}
                          <div className="row d-flex">
                            <div className="col-md-4 text-bold text-dark fs-4">
                              Phillipine:{" "}
                            </div>
                            <div className="col-md-8">
                              Follow-up Evaluation Mission 2024
                            </div>
                          </div>

                          <div className="row d-flex">
                            <div className="col-md-4 text-bold text-dark fs-4">
                              Mission Preferred:{" "}
                            </div>
                            <div className="col-md-8">Yearly</div>
                          </div>
                          <div className="row d-flex">
                            <div className="col-md-4 text-bold text-dark fs-4">
                              Reason for Request:{" "}
                            </div>
                            <div className="col-md-8">........</div>
                          </div>
                          <div className="row d-flex">
                            <div className="col-md-4 text-bold text-dark fs-4">
                              Leader Name:{" "}
                            </div>
                            <div className="col-md-8">Jennifer Lasley</div>
                          </div>
                          <div className="row d-flex">
                            <div className="col-md-4 text-bold text-dark fs-4">
                              Member Name:{" "}
                            </div>
                            <div className="col-md-8">Oshin Dhand</div>
                          </div>
                          <div className="row d-flex">
                            <div className="col-md-4 text-bold text-dark fs-4">
                              Trainee Name:{" "}
                            </div>
                            <div className="col-md-8">Anas</div>
                          </div>
                          <div className="row d-flex">
                            <div className="col-md-4 text-bold text-dark fs-4">
                              Peer Reviewer Name:{" "}
                            </div>
                            <div className="col-md-8">Sara</div>
                          </div>
                          <div className="row d-flex">
                            <div className="col-md-4 text-bold text-dark fs-4">
                              Observer Name:{" "}
                            </div>
                            <div className="col-md-8">GoldSmith</div>
                          </div>
                          <div className="row d-flex">
                            <div className="col-md-4 text-bold text-dark fs-4">
                              Security Status:{" "}
                            </div>
                            <div className="col-md-8">Feasible (20-Mar-24)</div>
                          </div>
                          <div className="row d-flex">
                            <div className="col-md-4 text-bold text-dark fs-4">
                              Funding Status:{" "}
                            </div>
                            <div className="col-md-8">........</div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 mb-4">
                        <TinyMCEEditor
                          value="PVS Evaluation Mission – Acknowledgement Receipt 

 

Dear Delegate, 

With reference to your letter dated 28 April 2022 (Ref. RSS/MLF/DVS/Jb/25.2/31/1), requesting that WOAH carries out a PVS Evaluation mission in your country, I am pleased to inform you that a team of experts and dates to conduct this mission will be proposed to you for your approval in the near future.  

In order to gain time, please find enclosed the List of Baseline Documents that the Team Leader should receive beforehand, as soon as the team of experts has been identified and your agreement has been received.  

PVS Pathway missions aim at supporting your country in the strengthening of your Veterinary Services. To reach this important objective, it is important to have the support of high-level policy decision-makers. Therefore, I strongly suggest you arrange a meeting with the Ministry of Agriculture or his representative and PVS Experts during their visit in order to explain the relevance of the mission in terms of its potential use for strengthening the Veterinary Services of your country. For further information on the organisation of PVS Evaluation missions, I recommend you consult the WOAH website: https://www.woah.org/en/what-we-offer/improving-veterinary-services/  

International travel costs, per diem allowances (to cover hotel and other accommodation costs), and remuneration of the PVS Experts that will participate in this mission will be covered by WOAH. However, it is expected that your government will take care of the expenses related to local travel and transport, logistical support to Experts, interpretation services (if necessary), the cost of the participation of the local team from your services, and any other expenses deemed appropriate to support the mission."
                        />
                        {/* <TextFieldCustom
                  id="outlined-multiline-flexible"
                  label={t("279", "Comments")}
                  multiline
                  rows={5}
                  //maxRows={5}
                  value={form.comments}
                  onChange={(e) =>
                    setForm({ ...form, comments: e.target.value })
                  }
                  fullWidth
                  size="small"
                /> */}
                      </div>
                      <div className="col-md-12 mb-3">
                        <div
                          id="dropzone"
                          className="border border-2 text-center mx-auto"
                          style={{
                            height: "200px",
                            width: "200px",
                          }}
                        >
                          <input
                            type="file"
                            onChange={handleFileChange}
                            accept=".pdf, .doc, .docx, .txt"
                            style={{ display: "none" }}
                            id="fileInput"
                          />
                          <label htmlFor="fileInput">
                            <img
                              src={uploadImage}
                              id="upload-img"
                              className="w-75"
                              alt="upload-file"
                            />
                            <p>
                              {t("33", "Drag and drop or click to upload file")}
                            </p>
                          </label>
                        </div>
                      </div>
                      <div className="d-flex mt-3">
                        <button
                          className="btn btn--primary fs-7 lh-1 ms-auto"
                          //   disabled={checkRequestSent}
                          onClick={() => handleSave()}
                        >
                          {t("85", "Save")}
                          <i className="fa-sharp fas fa-check text-white ms-2"></i>
                        </button>
                      </div>
                    </>
                  )}

                {USER_ROLES.delegate.includes(parseInt(authData.role_id)) && (
                  <>
                    <div className="col-12 bg-beige mb-3">
                      <div className=" p-3 text-dark">
                        {/* <div className="row d-flex">
                            <div className="col-md-4 text-bold text-dark fs-4">Country Name: </div>
                            <div className="col-md-8 text-bold">Phillipine</div>
                        </div> */}
                        <div className="row d-flex">
                          <div className="col-md-4 text-bold text-dark fs-4">
                            Mission Type Requested:{" "}
                          </div>
                          <div className="col-md-8">
                            Follow-up Evaluation Mission 2024
                          </div>
                        </div>
                        <div className="row d-flex">
                          <div className="col-md-4 text-bold text-dark fs-4">
                            Mission Preferred:{" "}
                          </div>
                          <div className="col-md-8">Yearly</div>
                        </div>
                        <div className="row d-flex">
                          <div className="col-md-4 text-bold text-dark fs-4">
                            Reason for Request:{" "}
                          </div>
                          <div className="col-md-8">........</div>
                        </div>
                        <div className="row d-flex">
                          <div className="col-md-4 text-bold text-dark fs-4">
                            Mission Preferred:{" "}
                          </div>
                          <div className="col-md-8">Yearly</div>
                        </div>
                        <div className="row d-flex">
                          <div className="col-md-4 text-bold text-dark fs-4">
                            Reason for Request:{" "}
                          </div>
                          <div className="col-md-8">........</div>
                        </div>
                        <div className="row d-flex">
                          <div className="col-md-4 text-bold text-dark fs-4">
                            Leader Name:{" "}
                          </div>
                          <div className="col-md-8">Jennifer Lasley</div>
                        </div>
                        <div className="row d-flex">
                          <div className="col-md-4 text-bold text-dark fs-4">
                            Member Name:{" "}
                          </div>
                          <div className="col-md-8">Oshin Dhand</div>
                        </div>
                        <div className="row d-flex">
                          <div className="col-md-4 text-bold text-dark fs-4">
                            Trainee Name:{" "}
                          </div>
                          <div className="col-md-8">Anas</div>
                        </div>
                        <div className="row d-flex">
                          <div className="col-md-4 text-bold text-dark fs-4">
                            Peer Reviewer Name:{" "}
                          </div>
                          <div className="col-md-8">Sara</div>
                        </div>
                        <div className="row d-flex">
                          <div className="col-md-4 text-bold text-dark fs-4">
                            Observer Name:{" "}
                          </div>
                          <div className="col-md-8">GoldSmith</div>
                        </div>
                        <div className="row d-flex">
                          <div className="col-md-4 text-bold text-dark fs-4">
                            Security Status:{" "}
                          </div>
                          <div className="col-md-8">........</div>
                        </div>
                        <div className="row d-flex">
                          <div className="col-md-4 text-bold text-dark fs-4">
                            Funding Status:{" "}
                          </div>
                          <div className="col-md-8">........</div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 mb-3">
                      <div
                        id="dropzone"
                        className="border border-2 text-center mx-auto"
                        style={{
                          height: "200px",
                          width: "200px",
                        }}
                      >
                        <input
                          type="file"
                          onChange={handleFileChange}
                          accept=".pdf, .doc, .docx, .txt"
                          style={{ display: "none" }}
                          id="fileInput"
                        />
                        <label htmlFor="fileInput">
                          <img
                            src={uploadImage}
                            id="upload-img"
                            className="w-75"
                            alt="upload-file"
                          />
                          <p>
                            {t("33", "Drag and drop or click to upload file")}
                          </p>
                        </label>
                      </div>
                    </div>
                    <div className="col-12 mb-4">
                      {/* <TextFieldCustom
                id="outlined-multiline-flexible"
                label={t("279", "Comments")}
                multiline
                rows={5}
                //maxRows={5}
                value={form.comments}
                onChange={(e) =>
                  setForm({ ...form, comments: e.target.value })
                }
                fullWidth
                size="small"
              /> */}
                      <TinyMCEEditor />
                    </div>
                    <div className="d-flex mt-3">
                      <button
                        className="btn btn--primary fs-7 lh-1 ms-auto"
                        //   disabled={checkRequestSent}
                        onClick={() => handleSave()}
                      >
                        {t("85", "Save")}
                        <i className="fa-sharp fas fa-check text-white ms-2"></i>
                      </button>
                    </div>
                  </>
                )}
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default ARMissionManager;
